import { useEffect } from 'react';

export const SITE_URL = 'https://waku-waku.biz';

interface SeoOptions {
  title: string;
  description: string;
  path: string;
  keywords?: string;
  image?: string;
  noindex?: boolean;
}

function setMetaByName(name: string, content: string) {
  let el = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setMetaByProperty(property: string, content: string) {
  let el = document.querySelector<HTMLMetaElement>(`meta[property="${property}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('property', property);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

/**
 * ページごとに title / description / canonical / OG / Twitter タグを上書きする。
 * SPA なので index.html の静的タグはホーム画面の初期値に過ぎず、
 * サブページではここで実URLに合わせて書き換える。
 */
export function useSeo({ title, description, path, keywords, image, noindex }: SeoOptions) {
  useEffect(() => {
    const url = `${SITE_URL}${path}`;
    const ogImage = image ?? `${SITE_URL}/og-image.jpg`;

    document.title = title;
    setMetaByName('description', description);
    if (keywords) setMetaByName('keywords', keywords);
    setMetaByName('robots', noindex ? 'noindex,follow' : 'index,follow');

    let canonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', url);

    setMetaByProperty('og:url', url);
    setMetaByProperty('og:title', title);
    setMetaByProperty('og:description', description);
    setMetaByProperty('og:image', ogImage);
    setMetaByName('twitter:title', title);
    setMetaByName('twitter:description', description);
    setMetaByName('twitter:image', ogImage);
  }, [title, description, path, keywords, image, noindex]);
}
